import React, { useState } from 'react';
import { Button, Modal } from 'tt-ui-lib/core';
import styles from './ReportDelete.module.scss';
import { deleteDraft, deleteResult } from 'api/reports/endpoints/reports';
import { ReactComponent as DeleteSvg } from '../../../../assets/svg/delete.svg';

const BUTTON_TEXT = `Delete`;
const TITLE = `Delete report`;
const MESSAGE = `Are you sure you want to delete the report`;

const ReportDelete = (props) => {
  const {
    buttonType = 'default',
    draftId,
    draftName,
    onError,
    isDraft = true,
    onDelete = null,
    onSuccess = null,
    buttonText = BUTTON_TEXT,
    message = MESSAGE,
    title = TITLE,
  } = props;

  const [isReportModalOpened, setIsReportModalOpened] = useState();

  const modalDeleteOpen = () => {
    setIsReportModalOpened(true);
  };

  const closeDeleteModal = () => {
    setIsReportModalOpened(false);
  };

  const onDeleteDraft = async () => {
    (isDraft ? deleteDraft({ id: draftId }) : deleteResult({ id: draftId }))
      .then((resp) => {
        const { data, success } = resp.data;
        if (success && onSuccess) onSuccess(data);
      })
      .catch((err) => {
        onError(err);
      })
      .finally(() => {
        if (onDelete) {
          onDelete(draftId);
        }
        closeDeleteModal();
      });
  };

  return (
    <>
      <Modal
        open={isReportModalOpened}
        onClose={closeDeleteModal}
        onClick={(e) => e.stopPropagation()}
        title={title}
        className={styles.warningModal}
      >
        <div>{`${message} "${draftName}"?`}</div>
        <div className={styles.buttonBlock}>
          <Button type="default" onClick={() => closeDeleteModal}>
            Cancel
          </Button>
          <Button type="primary" onClick={onDeleteDraft}>
            {buttonText}
          </Button>
        </div>
      </Modal>
      <Button type={buttonType} id={styles.deleteButton} onClick={modalDeleteOpen}>
        {buttonType === 'icon' ? <DeleteSvg /> : buttonText}
      </Button>
    </>
  );
};

export default ReportDelete;
